module.exports = __webpack_public_path__ + "img/product_21.1572e08.webp";